import { To } from 'react-router-dom'

import { Avatar, Box, Card } from '@factorialco/deprecated-design-system'
import {
  PerformanceGoalsEmployeeProgressFragment,
  PerformanceGoalsKeyResultsCardFragment,
} from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { ProgressSummary } from '../ProgressSummary'

type GoalsEmployee = PerformanceGoalsKeyResultsCardFragment & {
  progresses?: PerformanceGoalsEmployeeProgressFragment[]
}

interface Props {
  goalsEmployee: GoalsEmployee
  to: To
  isYou?: boolean
}

export const KeyResultsCard: React.FC<Props> = ({ goalsEmployee, to, isYou }) => {
  const { employee } = goalsEmployee
  if (!employee) return null

  const metricSummary = goalsEmployee.metricSummary
  const cycleProgress = goalsEmployee.progresses?.[0]

  return (
    <Box minWidth="s300">
      <Card to={to}>
        <Card.Eyebrow>
          <Avatar label={employee.fullName} url={buildUrl(employee.access?.avatar)} />
        </Card.Eyebrow>
        <Card.Title>
          {isYou ? i18n.t('performance_goals.key_results_card.title_you') : employee.fullName}
        </Card.Title>
        <Card.Description>
          {i18n.t('performance_goals.key_results_card.description')}
        </Card.Description>
        <Card.Content>
          {(cycleProgress || metricSummary) && (
            <Box width="full">
              <ProgressSummary
                progress={cycleProgress?.progress ?? metricSummary?.averageProgress ?? 0}
                needsAttention={cycleProgress?.needsAttention ?? metricSummary?.needsAttention}
              />
            </Box>
          )}
        </Card.Content>
      </Card>
    </Box>
  )
}
